/**
 * Venue-level configuration — branding, tax, fees, and stadium timing.
 * Values are set per deployment via REACT_APP_* env vars.
 */

export interface VenueConfig {
  name: string;
  color: string;
  taxRate: number;
  serviceFee: number;
  kickoffAt?: string;
  walkSecPerSection: number;
  basePrepMin: number;
}

function parseRate(value: string | undefined, fallback: number): number {
  const parsed = parseFloat(value ?? String(fallback));
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : fallback;
}

const kickoffRaw = process.env.REACT_APP_KICKOFF_AT?.trim();

export const envVenueDefaults: VenueConfig = {
  name: process.env.REACT_APP_VENUE_NAME?.trim() || 'ONI Stadium',
  color: process.env.REACT_APP_VENUE_COLOR?.trim() || '#B10202',
  taxRate: parseRate(process.env.REACT_APP_TAX_RATE, 0.08),
  serviceFee: parseRate(process.env.REACT_APP_SERVICE_FEE, 2.5),
  kickoffAt: kickoffRaw || undefined,
  walkSecPerSection: parseRate(process.env.REACT_APP_WALK_SEC_PER_SECTION, 30),
  basePrepMin: parseRate(process.env.REACT_APP_BASE_PREP_MIN, 4),
};

/** @deprecated use VenueProvider settings — kept for boot-time fallback */
export const venueConfig: VenueConfig = envVenueDefaults;

export function formatTaxLabel(taxRate: number): string {
  const pct = taxRate * 100;
  const rounded = Math.round(pct * 10) / 10;
  return Number.isInteger(rounded) ? `Tax (${rounded}%)` : `Tax (${rounded.toFixed(1)}%)`;
}

export function calcOrderTotals(subtotal: number, settings: VenueConfig = envVenueDefaults) {
  const tax = subtotal * settings.taxRate;
  const total = subtotal + tax + settings.serviceFee;
  return { subtotal, tax, serviceFee: settings.serviceFee, total };
}
